module.exports = __webpack_public_path__ + "static/media/patronat_honorowy_prezydent_EN.e31bfde9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/patronat_honorowy_prezydent_EN.png
// module id = 1103
// module chunks = 0